module.exports = __webpack_public_path__ + "img/hand-icon-grey-outline-desktop.9c007914.svg";